import {ObjectList} from './object-list.model.interface';
import {ISimpleSelectableData} from './simple-selectable-data.model.interface';

export interface IParcelContentType {
  id: number;
  value: string;
  label: string;
}

export class IParcelContentTypeList extends ObjectList<IParcelContentType, IParcelContentType> {
  protected mapToListElement(instance: IParcelContentType): IParcelContentType {
    return instance;
  }

  protected mapToSelectableItem(instance: IParcelContentType): ISimpleSelectableData {
    return {
      value: instance.id,
      label: instance.label,
      enum: instance.value
    };
  }
}
